import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../Context/AppContext";
import useFetch, { api } from "../../services/api/api";
import {
  HomeContainer,
  Title,
  Button,
  Form,
  ButtonContainer,
  Text,
  SmallTitle,
  Logo,
} from "./style";
import { CSSTransition } from "react-transition-group";
import Loading from "../Loading";
import logo from "../../static/logo.svg";
import { WEBSOCKET_URL } from "../../config/config";

let websocket;

const Home = ({ history }) => {
  const {
    room,
    username,
    members,
    setMembers,
    setRoom,
    setUsername,
    setWebsocket,
  } = useContext(AppContext);
  const [home, setHome] = useState(true);
  const [join, setJoin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [roomCode, setRoomCode] = useState("");

  const { response } = useFetch({
    api,
    method: "get",
    url: "/room",
  });

  const onError = (e) => {
    e.preventDefault();
  };

  const handleJoinRoom = () => {
    websocket = new WebSocket(
      `${WEBSOCKET_URL}?token=${room}&username=${username}`
    );
    websocket.onerror = (e) => onError(e);
    setWebsocket(websocket);
    setMembers([...members, username]);
    history.push("/room");
  };

  useEffect(() => {
    if (response !== null) {
      setRoom(response[0].token);
    }
  }, [response, setRoom]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1500);
  }, []);

  return (
    <>
      {loading === false ? (
        <>
          {home && (
            <HomeContainer>
              <Logo src={logo}></Logo>
              <Title>Werewolf</Title>

              <Form
                placeholder="enter your username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              <ButtonContainer>
                <Button onClick={handleJoinRoom} disabled={!username}>
                  Create Room
                </Button>
                <Button
                  onClick={() => {
                    setJoin(true);
                    setRoomCode(room);
                    setRoom("");
                  }}
                  disabled={!username}
                >
                  Join Room
                </Button>
              </ButtonContainer>
            </HomeContainer>
          )}

          <CSSTransition
            in={join}
            classNames="page"
            timeout={300}
            unmountOnExit
            onEnter={() => setHome(false)}
            onExited={() => setHome(true)}
          >
            <HomeContainer>
              <SmallTitle>Werewolf</SmallTitle>
              <Text>Username : {username}</Text>

              <Form
                placeholder="enter room name"
                name="room"
                value={room}
                onChange={(e) => setRoom(e.target.value)}
              />

              <ButtonContainer>
                <Button
                  onClick={() => {
                    setJoin(false);
                    setRoom(roomCode);
                  }}
                >
                  Back
                </Button>
                <Button onClick={handleJoinRoom} disabled={!room}>
                  Join
                </Button>
              </ButtonContainer>
            </HomeContainer>
          </CSSTransition>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default withRouter(Home);
